import React, {Fragment, useEffect, useState, useCallback, useRef} from 'react'
import Menu from '../../components/Menu/Menu'
import { Button } from 'react-bootstrap';
import './ChatHistory.scss'
import axios from 'axios';
import { REACT_APP_WORKING_URL } from '../../Constants'
import Feedbacks from '../../components/Feedbacks/Feedbacks';
import {message, Drawer } from 'antd';


function ChatHistory() {
  const [ chatList, setChatList ] = useState([])
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const scrollableDivRef = useRef(null);
  const apiUrl = REACT_APP_WORKING_URL
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(()=>{
    if (scrollableDivRef.current) {
      const scrollableDiv = scrollableDivRef.current;
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    }
  },[chatList])

  useEffect(()=>{
    if (scrollableDivRef.current) {
      const scrollableDiv = scrollableDivRef.current;
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    }
  },[chatList])

  useEffect(()=>{
    axios.post(`${apiUrl}chatting/getMyHistory`,{
      id:user.user_id
    },{
      headers: {
        authorization: `Bearer ${user.accessToken}`,
      },
    })
    .then((res)=>{
      const newArray = []
      res.data.map((item)=>{
        var date = new Date(item.timestamp);
        // 获取年、月、日、时、分、秒
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, "0");
        var day = String(date.getDate()).padStart(2, "0");
        var hours = String(date.getHours()).padStart(2, "0");
        var minutes = String(date.getMinutes()).padStart(2, "0");
        var seconds = String(date.getSeconds()).padStart(2, "0");
        var formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        newArray.push({
          content:item.message_question,
          role:"user",
          time:formattedTimestamp,
        })
        newArray.push({
          ...item,
          id:item.message_id,
          content:item.message_answer,
          role:"assistant",
          time:formattedTimestamp,
          feedback:item.user_feedback
        })
      })
      setChatList(newArray)
    })
    .catch((err)=>{
      console.log(err)
    })
  },[])

  const updateFeedback = (msgId, feedback)=>{
    const newCL = JSON.parse(JSON.stringify(chatList));
    newCL.forEach((item)=>{
      if(item.id === msgId){
        item.feedback = feedback
      }
    })
    console.log('newCL', newCL);
    setChatList(newCL);
  }

  const onClose = () => {
    setOpen(false);
  };
  
  return (
    <div className='chathistory'>
      <div className='container mt-5 d-flex justify-content-between'>
      <Menu/>
      <div className='d-flex align-items-center chathistory-title'>CHAT HISTORY</div>
    </div>
     <div ref={scrollableDivRef} className='w-100 chathistory-scroll container'>
     {
       chatList && chatList.length > 0 ?
       chatList.map((item, index)=>{
         if(item.role && item.role === 'user'){
           return(
             <div key={index} className='w-100 d-flex justify-content-end'>
               <div className='chathistory-chat-user'>
               <div dangerouslySetInnerHTML={{ __html: item.content.replace(/\n/g, "<br>") }}></div>
               <div className='w-100 d-flex justify-content-end'>{item.time}</div>
               </div>
             </div>
           )
         }
         else if(item.role && item.role === 'assistant'){
           return(
            <div key={index+"_"+item.feedback} className='d-flex flex-row'>
             <div className='d-flex flex-column justify-content-start chathistory-chat-assistant'>
               <div>
                <div dangerouslySetInnerHTML={{ __html: item.content.replace(/\n/g, "<br>") }}></div>
               </div>
               <div className='w-100 d-flex justify-content-end'>
                 {item.time}
               </div>
             </div>
              <Feedbacks updateFeedback={updateFeedback} setOpen={setOpen} setContent={setContent} {...item}/>
            </div>
           )
         }
       })
       :
       null
     }
    <Drawer title='The most relative sources' placement="right" onClose={onClose} open={open}>
      {content}
    </Drawer>
   </div>
   <div className='w-100 mb-5 p-0'>
      <Button type="submit" className='container chathistory-clear' onClick={()=>{
        if(window.confirm("Are you sure you want to clear all chating history?")){
          axios.delete(`${apiUrl}chatting/deleteMyHistory/${user.user_id}`, {
            headers: {
              authorization: `Bearer ${user.accessToken}`,
            },
          })
          .then(res=>{
            alert('Delete all history successfully!')
            window.location.reload()
          })
          .catch(err=>{
            if(err.response.status == 404){
              alert('The history is already empty!')
            }
          })
          // ClearAllChat()
      }}}>
        Clear All History
      </Button>
   </div>
  </div>
  )
}

// const mapStateToProps = (state) => ({
//   chat: state.chat,
//   user: state.auth.user
// });

// const mapDispatchToProps = {
//   AddNewChat,
//   GetAllChat,
//   ClearAllChat 
// };

// export default connect(mapStateToProps, mapDispatchToProps)(ChatHistory);
export default (ChatHistory);